<app-import-type-selector
  *ngIf="currentView === 'select-type'"
  (typeSelected)="onTypeSelected($event)"
  (cancel)="onBack()"
  (filterFileSelected)="handleExportMissingFileInput($event)">
</app-import-type-selector>

<app-import-source
  *ngIf="currentView === 'select-source'"
  [importType]="selectedImportType"
  [importingType]="importingType"
  [corruptedImages]="corruptedImages"
  [availableSourceIds]="availableSourceIds"
  (back)="onBack()"
  (importCsv)="onImportCsv($event)"
  (importDirect)="onImportDirect($event)"
  (viewResults)="onViewResults()">
</app-import-source>

<div *ngIf="exportCompleted" class="exportResultWrapper">
  <p [class.exportResultError]="exportMissingProductsCount === 0">
    {{ 'Found' | translate }} {{ exportTotalProducts }} {{ 'products in the file' | translate }},
    {{ exportExistingProducts }} {{ 'already in your store' | translate }}.
    {{ 'Exported' | translate }} {{ exportMissingProductsCount }} {{ 'new products' | translate }}.
  </p>
</div>
